import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import ChatCustomer from '../components/ChatCustomer'
import RecentSuccessOperation from '../components/RecentSuccessOperation'
import ServiceDisponible from '../components/ServiceDisponible'
import SupportCommunity from '../components/SupportCommunity'
import './homeScreen.css'
import { Box, Button, CardActionArea, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'
import Carousel from 'react-multi-carousel';
import coinGecko from '../api/coinGecko'
import CampaignIcon from '@mui/icons-material/Campaign';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSignInAlt, faSignOutAlt, faSync } from '@fortawesome/free-solid-svg-icons';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import NumbersStatus from '../components/NumbersStatus'
import Variations from '../components/Variations'
import 'animate.css';
import ServiceLists from '../components/ServiceLists'
import Banner from '../components/Banner'

const HomeScreen = (props) => {

  var   _ProWallet = localStorage.getItem('_ProWallet')
  const Logged = localStorage.getItem('userStatus')

  const [ownWitness, setOwnWitness] = useState([])
  const [WitnessesStopReq, setWitnessesStopReq] = useState(false)

  const [USDTRateStop, setUSDTRateStop] = useState(false)
  const [NT_rateUSDT, setNT_rateUSDT] = useState([])

  const [USDTRate2Stop, setUSDTRate2Stop] = useState(false)
  const [NT_rate2USDT, setNT_rate2USDT] = useState([])

  const LineLink = true
  // const LineLink = false
    
  useEffect(()=>{

      const fetchData = async () => {

          if(!USDTRateStop){

              try {
                  const res = await axios.get('/api/nt-rateusdt')

                  if(res.data[0].ID){
                      setNT_rateUSDT(res.data[0].usdt)
                      setUSDTRateStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[USDTRateStop])

  useEffect(()=>{
  
      const fetchData = async () => {
  
          if(!USDTRate2Stop){
  
              try {
                  const res = await axios.get('/api/nt-rate2usdt')
  
                  if(res.data[0].ID){
                      setNT_rate2USDT(res.data[0].usdt)
                      setUSDTRate2Stop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()
  
  },[USDTRate2Stop])

  var dashAction = props.location.hash.slice(1, 17)
  var homePath  = props.location.pathname.slice(1, 5)
  var firstPath = props.match.path

  useEffect(() => {
    if (homePath !== "home" && Logged === 'Logout') {

      if(LineLink){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
         window.location.replace("http://localhost:3000/login");
      }
    }

    if((homePath === "home" || firstPath === '/') && Logged === 'Logged'){
        
      if (_ProWallet === 'true') {

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
       }
       
    }

  }, [Logged, props.history, dashAction, homePath, _ProWallet, firstPath, LineLink])

  const [isMenuVisible, setMenuVisibility] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

  const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isVisible = prevScrollPos > currentScrollPos;
  
      setMenuVisibility(isVisible);
      setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [prevScrollPos]);

  const STATUS = { STARTED: 'Traitement en cours...', }
  
    const INITIAL_COUNT1 = 300
  
    const [secondsRemaining1,            setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
    const [status1,                      setStatus1           ] = useState(STATUS.STOPPED)
  
    useEffect(()=>{
      setStatus1(STATUS.STARTED)
    },[STATUS.STARTED])

  useInterval(
    () => {
    if (secondsRemaining1 > 0) {
        setSecondsRemaining1(secondsRemaining1 - 1)
    } else {
        setStatus1(STATUS.STOPPED)
    }
    },

    status1 === STATUS.STARTED ? 1000 : null,
    // passing null stops the interval
)

function useInterval(callback, delay) {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
    savedCallback.current = callback
    }, [callback])

// Set up the interval.
useEffect(() => {
  function tick() {
    savedCallback.current()
  }
  if (delay !== null) {
    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }
}, [delay])
}

var [themeMode, setThemeMode] = useState()

let ThemeMode = localStorage.getItem("ThemeMode")

useEffect(()=>{
  
  if(secondsRemaining1 > 0){
    setThemeMode(ThemeMode)
  }

},[ThemeMode, secondsRemaining1])



  useEffect(() => {
    const fetchWitnessDada = async () => {
      try {
        if (!WitnessesStopReq) {
          const { data } = await axios.get(
            '/api/v1/get-witnesses',
          )
          if (data) {
            const _data = data
            const items = _data.slice(0, 3)
            setOwnWitness(items)
          }
          if (data.length > 0) {
            setWitnessesStopReq(true)
          }
        }
      } catch (error) { }
    }
    fetchWitnessDada()
  }, [ownWitness, WitnessesStopReq])

  const serviceLists = [
    {
      ID: 1,
      isActivated: 1,
      serviceImageLink: "../images/usdt.png",
      serviceName: "Tether(USDT)",
      serviceSymbol: "USDT"
    },
    {
      ID: 2,
      isActivated: 1,
      serviceImageLink: "../images/bnb.png",
      serviceName: "Binance Smart Chain",
      serviceSymbol: "BNB"
    },
    {
      ID: 3,
      isActivated: 1,
      serviceImageLink: "../images/btc.png",
      serviceName: "Bitcoin",
      serviceSymbol: "BTC"
    },
    {
      ID: 4,
      isActivated: 1,
      serviceImageLink: "../images/ltc.png",
      serviceName: "Litecoin",
      serviceSymbol: "LTC"
    },
    {
      ID: 5,
      isActivated: 1,
      serviceImageLink: "../images/doge.png",
      serviceName: "Dogecoin",
      serviceSymbol: "DOGE"
    },
    {
      ID: 6,
      isActivated: 1,
      serviceImageLink: "../images/payeer.png",
      serviceName: "Payeer",
      serviceSymbol: "PAYEER"
    },
    {
      ID: 7,
      isActivated: 1,
      serviceImageLink: "../images/pm.png",
      serviceName: "Perfect Money",
      serviceSymbol: "PM"
    },
    {
      ID: 8,
      isActivated: 1,
      serviceImageLink: "../images/tron.png",
      serviceName: "TRON",
      serviceSymbol: "trx"
    },
    {
      ID: 9,
      isActivated: 1,
      serviceImageLink: "../images/busd.png",
      serviceName: "Binance USD",
      serviceSymbol: "BUSD"
    },
    {
      ID: 10,
      isActivated: 1,
      serviceImageLink: "../images/shiba.png",
      serviceName: "Shiba Inu",
      serviceSymbol: "SHIB"
    },
    {
      ID: 11,
      isActivated: 1,
      serviceImageLink: "../images/polygonmatic.png",
      serviceName: "Polygon",
      serviceSymbol: "MATIC"
    },
    {
      ID: 12,
      isActivated: 1,
      serviceImageLink: "../images/eth.png",
      serviceName: "Ethereum",
      serviceSymbol: "ETH"
    },
    {
      ID: 13,
      isActivated: 1,
      serviceImageLink: "../images/pokadot.png",
      serviceName: "Polkadot",
      serviceSymbol: "DOT"
    },
    {
      ID: 14,
      isActivated: 1,
      serviceImageLink: "../images/chainlink.png",
      serviceName: "Chainlink",
      serviceSymbol: "LINK"
    },
    {
      ID: 15,
      isActivated: 1,
      serviceImageLink: "../images/cardano.png",
      serviceName: "Cardano",
      serviceSymbol: "ADA"
    },
    {
      ID: 16,
      isActivated: 1,
      serviceImageLink: "../images/solana.png",
      serviceName: "Solana",
      serviceSymbol: "SOL"
    },
  ]

  let imgUrl = '../../images/bg-bitcoin.png'

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  // home image and css params ==>  style={{ backgroundImage: `url(${imgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}

  function handleStartOperation(){

    if(LineLink){
    
      if(Logged === 'Logout'){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
        window.location.replace("https://nkab-exchange.net/sell-or-buy-crypto");
      }
      
    } else {
    
      if(Logged === 'Logout'){
        window.location.replace("http://localhost:3000/login");
      } else {
        window.location.replace("http://localhost:3000/sell-or-buy-crypto");
      }
    }
  }

  const [coins2, setCoins2] = useState([])

  useEffect(()=>{
    
    const fetchDada2 = async () => {

      const response = await coinGecko.get('/coins/markets', {
        params: {
          vs_currency: 'usd',
          ids:
            'bitcoin,tether,binancecoin,binance-usd,tron,litecoin,dogecoin',
        },
      })
      if(response.data.length > 0){
        setCoins2(response.data)
      }
    }
    fetchDada2()
  },[])

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {

    setOpen(false);

    if(LineLink){
      window.location.replace("https://nkab-exchange.net/login");
    } else {
       window.location.replace("http://localhost:3000/login");
    }

  };

  function handleLogout(){

    localStorage.clear();

    if(_ProWallet === "true"){
      localStorage.setItem("isRActive",false)
      localStorage.setItem("_ProWallet", true)
      localStorage.setItem("userStatus", "Logout")

      if(LineLink){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
         window.location.replace("http://localhost:3000/login");
      }
    }
    if(_ProWallet === "false"){
      localStorage.setItem("isRActive",false)
      localStorage.setItem("_ProWallet", false)
      localStorage.setItem("userStatus", "Logout")
    }
    
    localStorage.setItem("isRActive",false)

    if(LineLink){
      window.location.replace("https://nkab-exchange.net/login");
    } else {
       window.location.replace("http://localhost:3000/login");
    }
  }

  return (
    <div>
        <div className={`${themeMode === "true" ? "d-flex justify-content-center nkab-lite-rate-t p-3 mt-4" : "d-flex justify-content-center nkab-lite-rate p-3 mt-4"}`} style={{color:`${themeMode === "true" ? "#90d9ff" : "#00360c"}`}}>
          <div className="col-sm-12">
            <div className="text-center">
            <span><CampaignIcon style={{fontSize:"30px"}}/></span> Taux d'achat <span>1 USD = {NT_rateUSDT} XOF</span> Taux de vente <span>1 USD = {NT_rate2USDT} XOF</span> <span className='ml-4 nkab-lite-start pointer' onClick={Logged === 'Logout'?handleClickOpen:handleStartOperation}>COMMENCEZ ICI</span>
            </div>
          </div>
        </div>
        <Dialog
          open={open}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Vous souhaitez effectuer une opération?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Vous devez vous connecter pour commencer <EmojiEmotionsIcon style={{color:"#c7b301"}} /> !
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}> Fermer </Button>
            <Button onClick={handleClose2} sx={{ bgcolor: '#c7b301' }}>Se connecter</Button>
          </DialogActions>
        </Dialog>

      <section id="banner">
        <div>

          {/* <div className='d-flex justify-content-center mb-5'>
            <span className='nkab-cryptocurrency-home-image'> <img src="../../images/nkab-cryptocurrency-home-image2.png" width="310" height="275" alt="logo nkab" /> </span>
            <div className={`${themeMode === "true" ? "text-center wellcome-title wellcome-title-t" : "text-center wellcome-title"}`}>
              <h1 className='mb-4'>Achetez et Vendez en toute sécurité à des prix abordables ! </h1>
              <h6> Vous satisfaire dans le monde de la crypto-monnaie est notre priorité. </h6>
            </div>
          </div> */}

          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-4'>
              <div>
                <div className='nkab-cryptocurrency-home-image d-flex justify-content-center'> <img className='home-currency-img' src="../../images/nkab-cryptocurrency-home-image1.png" width="600" alt="nkab home" /> </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className={`${themeMode === "true" ? "text-center wellcome-title wellcome-title-t" : "text-center wellcome-title"}`}>
                <h1 className='mb-4 animate__animated animate__zoomInDown'>Achetez et Vendez en toute sécurité à des prix abordables ! </h1>
                <h6 className='animate__animated animate__backInRight'> Vous satisfaire dans le monde de la crypto-monnaie est notre priorité. </h6>
              </div>
              <div className='d-flex justify-content-center animate__fadeInDown animate__animated'>
                <Box noValidate sx={{ mt: 1, width:'50%' }}>
                  <Button
                    fullWidth
                    variant="contained"
                    className='home-btn'
                    onClick={Logged === 'Logout'?handleClickOpen:handleStartOperation}
                    sx={{ mt: 3, mb: 2, bgcolor: '#c7b301', fontWeight:'800', fontSize:'15px', color:'#0c1886' }}
                  >
                    COMMENCEZ MAINTENANT
                  </Button>
                </Box>
              </div>
            </div>
            <div className='col-md-2'></div>
          </div>

          <div>
            <div className="row text-center animate__animated animate__backInLeft">
              <div className="text-center">
                <div className='container'>
                  {/* <Banner/><br/> */}
                  <ServiceLists themeMode={themeMode} serviceLists={serviceLists}/>
                  <NumbersStatus />
                  <Variations />

                  <div className={`${themeMode === "true" ? "nkab-com-t" : "nkab-com"}`}>
                    <SupportCommunity />
                    <div className='pb-5'>
                      <a href="https://play.google.com/store/apps/details?id=com.scdigital.nkabexchange&fbclid=IwAR2Jv1Yh" className="playstore nkab" title="Facebook">
                        <img src="../../images/playstore.png" alt="" width="155" height="50" />
                      </a>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          {/* <img
            src="../../images/wave.png"
            alt=""
            className="bottom-img"
            style={{ background: '#d6f1ff !importent' }}
          /> */}
        </div>
      </section>

      <section id='allservices'>
        <div className="_our-wrapper">
          <div className="_our-header">
            <h1 className="header__title" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Avec vous partout où vous vous trouvez</h1>
            <h2 className="header__subtitle" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Nos monnaies numériques | Les pays où nous sommes représentés | Nos moyens de paiement</h2>
          </div>

          <div className="_our-cards">

            <div className="_our-card [ is-collapsed ]">
              <div className={`${themeMode === "true" ? "card__inner card__inner-t [ js-expander ]" : "card__inner [ js-expander ]"}`}>
                <div><p className='card_subtitle' style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>Nos monnaies numériques</p></div>
                <div style={{ paddingBottom: '5px' }}>
                  <span><img src="../../images/btc.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/usdt.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/bnb.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/doge.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/ltc.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/pm.png" alt="" className="card__inner-img" /> </span>
                </div>
                <div>
                  <span><img src="../../images/payeer.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/shiba.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/solana.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/tron.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/chainlink.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/ripple.png" alt="" className="card__inner-img" /> </span>
                </div>
                <div>
                  <span><img src="../../images/polygonmatic.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/pokadot.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/cardano.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/busd.png" alt="" className="card__inner-img" /> </span>
                </div>
              </div>
            </div>

            <div className=" _our-card [ is-collapsed ] ">
              <div className={`${themeMode === "true" ? "card__inner card__inner-t [ js-expander ]" : "card__inner [ js-expander ]"}`}>
                <div><p className='card_subtitle' style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>Les pays où nous intervenons</p></div>
                <div style={{ paddingBottom: '5px' }}>
                  <span><img src="../../images/ci_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/sen_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/mali_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/benin_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/togo_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/guinee_logo.png" alt="" className="card__inner-img" /> </span>
                </div>
                <div>
                  <span><img src="../../images/cam_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/burk_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/niger_logo.png" alt="" className="card__inner-img" /> </span>
                </div>
              </div>
            </div>

            <div className=" _our-card [ is-collapsed ] ">
              <div className={`${themeMode === "true" ? "card__inner card__inner-t [ js-expander ]" : "card__inner [ js-expander ]"}`}>
                <div><p className='card_subtitle' style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>Nos moyens de paiement disponibles</p></div>
                <div style={{ paddingBottom: '5px' }}>
                  <span><img src="../../images/om.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/momo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/flooz.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/wave.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/emoney.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/fm.png" alt="" className="card__inner-img" /> </span>
                </div>
                <div>
                  <span><img src="../../images/tm.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/visamastercard_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/wari_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/wu_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/ria_logo.png" alt="" className="card__inner-img" /> </span>
                  <span><img src="../../images/mg_logo.png" alt="" className="card__inner-img" /> </span>
                </div>
              </div>
            </div>
          </div>
          <ServiceDisponible />
          <RecentSuccessOperation /><br />
        </div>
      </section>

      <div className='mb-4 container'>
        <div className="_our-header">
          <h1 className="header__title" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}} >TEMOIGNAGES RECENTS</h1>
          <h2 className="header__subtitle" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Votre satisfaction notre motivation</h2>
        </div>
        <Carousel
              responsive={responsive}
              itemClass={`${themeMode === "true" ? "react-multi-carousel-item react-multi-carousel-item-t" : "react-multi-carousel-item"}`}
            >
        {
          ownWitness.map((item, index) => (
            <div key={index} sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div" style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>
                    {item.posterName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" style={{fontSize:"13px", color:`${themeMode === "true" ? "#cce8f7" : ""}`}}>
                    {item.witnessText}
                  </Typography>
                  <Typography gutterBottom variant="h5" component="div" style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>
                    <span style={{fontSize:'10px', fontStyle:'italic'}}>{item.updatedAt.slice(0,10)} à {Number(item.updatedAt.slice(11,13)) + 2}{item.updatedAt.slice(13,19)}</span>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </div>
          ))
        }
        </Carousel>
      </div>

      <ChatCustomer />

      <div className='nkp_diplay_container'>
          <div id="nkp_bottom_navbar" className={isMenuVisible ? 'visible' : 'hidden'}>
              <div className='nkab_ul'>
                  <div className="nkab_li">
                      <a href="/">
                          <span className="nkp_bottom_span"><FontAwesomeIcon style={{fontSize:"20px", color: "#c7b301"}} icon={faHome} /></span>
                          <span className='nkp_bottom_navbar_title'>Home</span>
                      </a>
                  </div>
                  <div className="nkab_li">
                      <a href="/sell-or-buy-crypto">
                          <span className="nkp_bottom_span"><FontAwesomeIcon style={{fontSize:"20px"}} icon={faSync} /></span> 
                          <span className='nkp_bottom_navbar_title'>Exchange</span>
                      </a>
                  </div>
                  <div className="nkab_li">
                      <a href="#logout" onClick={handleLogout}>
                          <span className="nkp_bottom_span"><FontAwesomeIcon style={{fontSize:"20px"}} icon={Logged === 'Logged'?faSignOutAlt:faSignInAlt} /></span>
                          <span className='nkp_bottom_navbar_title'>{Logged === 'Logged'?"Logout":"login"}</span>
                      </a>
                  </div>
              </div>
          </div>
      </div>

    </div>
  )
}



export default HomeScreen

